import {cs} from "@Common/react/chain-services";

import {UserAssetsLayout1} from "../common/layout/user-assets-layout";

export const AccountAdminScheduledCampaignsRoute = ({match}) => cs(
    ["layout", ({}, next) => UserAssetsLayout1({
        activeTab: "admin-scheduled-campaigns",
        noPadding: true,
        hideTabs: true,
        mobileHideBackLink: true,
        next,
    })],

    ["scPanel", ({layout}, next) => layout.renderScheduledCampaignsPanel({
        initStep: match.params.step,
        next,
    })],
    ({layout, scPanel}) => layout.render({
        navBlock: scPanel.navBlock,
        next: () => scPanel.render(),
    }),
);
